import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import UpperLobePiercingImage from '../../Assets/Piercing Services/upper lobe piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function UpperLobePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
            <title>Upper Lobe Piercing Dubai, UAE </title>
            <meta
                name="description"
                content="Upper Lobe Piercing Dubai, UAE with professional service, high-quality products and strict hygiene standards for a safe and stylish piercing experience. "
            />        
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Upper Lobe Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Upper Lobe Piercing 100-125 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={UpperLobePiercingImage} alt="Upper Lobe Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Upper Lobe Piercing</h3>

          <p>
            Enhance your ear styling with our professional upper lobe piercing services in the UAE, available at an affordable price range of 100–125 AED. Upper lobe piercing is a stylish and modern choice, placed on the upper part of the ear lobe, making it perfect for layering multiple earrings and creating a trendy, personalized look. Whether you want to complement your existing lobe piercings or start a curated ear style, our expert specialists ensure precise placement that enhances your overall appearance with balance and elegance.
          </p>

          <p>
            We are dedicated to providing safe, hygienic, and high-quality ear piercing services using sterile, single-use equipment and advanced techniques. Our certified professionals follow strict hygiene protocols to ensure a clean and infection-free experience for every client. Each upper lobe piercing is performed with care and precision, minimizing discomfort while ensuring optimal results. Our goal is to deliver a quick, smooth, and stress-free procedure that leaves you feeling confident and satisfied.
          </p>

          <p>
            Upper lobe piercing is ideal for individuals who want to experiment with layered jewelry styles, from minimal studs to stacked hoops. It is suitable for teens and adults who are looking to elevate their ear aesthetics with a fashionable touch. The procedure is simple and typically completed within minutes, making it a convenient option even for those with busy schedules. Our specialists use techniques that reduce pain and promote faster healing, allowing you to enjoy your new piercing with minimal downtime.
          </p>

          <p>
            We also offer a range of high-quality, hypoallergenic starter earrings that are safe for sensitive skin, helping to prevent irritation and allergic reactions. Our team provides personalized consultation to help you choose the best placement for your upper lobe piercing, ensuring it aligns perfectly with your existing piercings and desired style. Whether you prefer a subtle layered look or a bold stacked design, we tailor the experience to meet your preferences.
          </p>

          <p>
            Our clinic environment is clean, welcoming, and designed to make you feel comfortable throughout your visit. We understand that getting a new piercing can sometimes feel overwhelming, which is why our friendly professionals are always available to guide and support you. From consultation to completion, we ensure that every step of your experience is handled with professionalism and care.
          </p>

          <p>
            Aftercare is an important part of the healing process, and we provide detailed instructions to help you maintain your new piercing properly. Our team will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper care, upper lobe piercings heal efficiently and remain a long-lasting addition to your style.
          </p>

          <p>
            Our upper lobe piercing services in the UAE combine affordability with premium standards, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that suits your schedule. We strive to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted upper lobe piercing services in the UAE for a safe, stylish, and professional experience. With skilled specialists, sterile procedures, and a focus on customer satisfaction, we help you achieve a modern, layered ear look effortlessly. Book your upper lobe piercing appointment today and take your style to the next level with confidence and ease.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Upper Lobe Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default UpperLobePiercing;